import { ReactNode } from "react";

export enum ConnectionTypeEnum {
  SELECT = -1,
  NETWORK = 1,
  FTP = 2,
  LOCAL_DIRECTORY = 3,
  SFTP = 4,
}

export enum FileWriteBehaviorEnum {
  OVERWRITE = 1,
  ADDNUMERATOR = 2,
  SKIP = 3,
  APPEND = 4,
}

export enum OutputTypeEnum {
  ARCHIVE = 1,
  BACKUP = 2
}

export interface Connection {
  id: string;
  description: string;
  server: string;
  port: number | null;
  rootPath: string;
  username: string;
  useSsl: boolean;
  privateKey: string | null;
  passPhrase: string | null;
  connectionTypeEnum: ConnectionTypeEnum;
  createdBy: string;
}

export interface OutputType {
  value: OutputTypeEnum;
  label: string;
}

export interface FileWriteBehavior {
  value: FileWriteBehaviorEnum;
  label: string;
}

export interface OutputDestination {
  id: string;
  outputType: OutputType;
  connection: Connection;
  additionalPath: string;
  fileWriteBehavior: FileWriteBehavior;
}
export interface GridCellProps {
  dataItem: OutputDestination;
}

export interface OutputDestinationColumn {
  field: string;
  title: string;
  width: number;
  cell?: (props: GridCellProps) => ReactNode;
  filterable?: boolean;
}
